'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; /*
                                                                                                                                                                                                                                                                               * Copyright (C) 2018 Nettoken Ltd. All rights reserved.
                                                                                                                                                                                                                                                                               *
                                                                                                                                                                                                                                                                               * This document is the property of Nettoken Ltd.
                                                                                                                                                                                                                                                                               * It is considered confidential and proprietary.
                                                                                                                                                                                                                                                                               *
                                                                                                                                                                                                                                                                               * This document may not be reproduced or transmitted in any form,
                                                                                                                                                                                                                                                                               * in whole or in part, without the express written permission of
                                                                                                                                                                                                                                                                               * Nettoken Ltd.
                                                                                                                                                                                                                                                                               */


var _const = require('./const');

Object.keys(_const).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _const[key];
    }
  });
});

var _tldjs = require('tldjs');

var credentialNameMax = function credentialNameMax(str) {
  return stringMax(str, _const.CREDENTIAL_NAME_MAX_LENGTH);
};
var email = function email(str) {
  return exists(str) && _const.POLICY_EMAIL.test(str);
};

/**
 * @param {object} [args] Arguments to check. Should be an object,
 *   otherwise we cast it to an object and return the default state.
 * @param {object} [defaults] If arguments have any default parameters,
 *   we pick them from this parameter if they are undefined in `args`.
 *
 * @returns {object} Processed arguments with default values instead of
 *   undefined parameters.
 */
var ensureDefaults = function ensureDefaults(args, defaults) {
  if (!isObject(args)) args = {};
  if (isObject(defaults)) {
    Object.keys(defaults).forEach(function (key) {
      if (args[key] === undefined) args[key] = defaults[key];
    });
  }
  return args;
};

var exists = function exists(str) {
  return str !== undefined;
};

var formatPhoneNumber = function formatPhoneNumber(str) {
  var number = str || '';
  number = number.trim().replace(/ /g, '');
  if (!number.startsWith('+')) number = '+' + number;
  return number;
};

/**
 * @param {any} value
 *
 * @returns {boolean} Is this value an object?
 */
var isObject = function isObject(value) {
  return !!(value && (typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object' && !Array.isArray(value));
};

/*
 * Sometimes, domain parsing breaks. This wrapper tries to use `publicSuffix`
 * when that happens to salvage the result. Discussion about this issue and
 * the solution were proposed here:
 * https://github.com/oncletom/tld.js/issues/117#issuecomment-369150359.
 *
 * We switched to using hostname to limit extension scope to the subdomains
 * rather than root domains for security reasons.
 */
var parseDomain = function parseDomain(url) {
  var _parse = (0, _tldjs.parse)(url),
      domain = _parse.domain,
      hostname = _parse.hostname,
      publicSuffix = _parse.publicSuffix;

  var result = domain || hostname;
  if (hostname === null && publicSuffix) {
    result = publicSuffix;
  }
  return result;
};

var parseUrl = function parseUrl(raw) {
  var parsed = (0, _tldjs.parse)(raw);
  var domain = parseDomain(parsed.hostname);
  if (typeof domain === 'string') domain = domain.toLowerCase();

  var protoNeedle = '://';
  var protoIndex = raw.indexOf(protoNeedle);
  var protocol = raw.substr(0, protoIndex);
  var urlWithoutProtocol = protoIndex !== -1 ? raw.substr(protoIndex + protoNeedle.length) : raw;
  var pathIndex = urlWithoutProtocol.indexOf('/');
  var path = pathIndex !== -1 ? urlWithoutProtocol.substr(pathIndex) : '/';

  return {
    domain: domain,
    https: protocol === 'https',
    path: path,
    raw: raw
  };
};

var phone = function phone(str) {
  if (!exists(str)) return false;
  // Strip the initial '+' sign.
  if (str.startsWith('+')) str = str.substr(1);
  return _const.POLICY_PHONE.test(str);
};

var platform = function platform(str) {
  return _const.PLATFORMS.includes(str);
};

var stringMax = function stringMax(str, max) {
  return exists(str) && str.length <= max;
};
var strToInt = function strToInt(str) {
  return Number.parseInt(str, 10);
};

/*
 * We prepend URL with the `www` prefix as well as protocol because
 * certain URLs would not get parsed properly by `tldjs` otherwise
 * and cause errors. For example, `service.gov.uk`.
 */
var url = function url(str) {
  if (!exists(str)) return false;
  var domain = parseDomain(str);
  // If it's a valid domain, it will include at least one period symbol.
  if (!domain || !domain.includes('.') || !(0, _tldjs.isValid)(domain)) return false;
  // We may still end up with an IP address that passed all checks above.
  var willBeEmptyIfIPAddress = domain.replace(/[0-9.]/g, '');
  return !!willBeEmptyIfIPAddress;
};

var userAgeMax = function userAgeMax(str) {
  return exists(str) && strToInt(str) <= _const.USER_AGE_MAX;
};
var userAgeMin = function userAgeMin(str) {
  return exists(str) && strToInt(str) >= _const.USER_AGE_MIN;
};
var userEmailMax = function userEmailMax(str) {
  return stringMax(str, _const.USER_EMAIL_MAX_LENGTH);
};
var userLocationMax = function userLocationMax(str) {
  return stringMax(str, _const.USER_LOCATION_MAX_LENGTH);
};
var userNameMax = function userNameMax(str) {
  return stringMax(str, _const.USER_NAME_MAX_LENGTH);
};

var Validator = {
  credentialNameMax: credentialNameMax,
  email: email,
  ensureDefaults: ensureDefaults,
  exists: exists,
  formatPhoneNumber: formatPhoneNumber,
  isObject: isObject,
  /**
   * @param {string} host
   */
  isValidHost: _tldjs.isValid,
  parseDomain: parseDomain,
  parseUrl: parseUrl,
  phone: phone,
  platform: platform,
  strToInt: strToInt,
  url: url,
  userAgeMax: userAgeMax,
  userAgeMin: userAgeMin,
  userEmailMax: userEmailMax,
  userLocationMax: userLocationMax,
  userNameMax: userNameMax
};

exports.default = Validator;